<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <!-- logo -->
          <vuexy-logo />

          <h2 class="brand-text text-primary ml-1">
            Archistar
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          Hai scordato la Password? 🔒
        </b-card-title>
        <b-card-text class="mb-2">
          Inserisci la tua mail e ti invieremo un messaggio con le istruzioni da seguire
        </b-card-text>

        <!-- form -->
        <validation-observer ref="simpleRules">
          <b-form
            class="auth-forgot-password-form mt-2"
            @submit.prevent="validationForm"
          >
            <!-- email -->
            <b-form-group
              label="Email"
              label-for="forgot-password-email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="forgot-password-email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false:null"
                  name="forgot-password-email"
                  placeholder="john@example.com"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              block
              type="submit"
            >
              <span v-show="!loadingShow"> Invia link per il reset  </span>
              <b-spinner
                v-show="loadingShow"
                label="Attendi..."
              />
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <b-link :to="{name:'login'}">
            <feather-icon icon="ChevronLeftIcon" /> Torna al Login
          </b-link>
        </b-card-text>

      </b-card>
    <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BCard, BLink, BCardText, BCardTitle, BFormGroup, BFormInput, BForm, BButton, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const authRepository = RepositoryFactory.get('auth')

export default {
  components: {
    VuexyLogo,
    BSpinner,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      // validation
      required,
      email,
      loadingShow: false,
    }
  },
  methods: {
    async validationForm() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          this.loadingShow = true
          const { data } = await authRepository.forgot(this.userEmail)

          if (data.code) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Mail inviata!',
                icon: 'CheckIcon',
                variant: 'success',
              },
            }, {
              position: 'top-center',
            })
            this.loadingShow = false
            this.$router.push({ name: 'login' })
            console.log(data)
          } else {
            this.loadingShow = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Qualcosa è andato storto!',
                icon: 'XIcon',
                variant: 'danger',
              },
            }, {
              position: 'top-center',
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
